export function validateOrderBy(orderBy) {
    const valid = Boolean(orderBy && Object.keys(orderBy).length);
    if (!valid) {
        return undefined;
    }
    return orderBy;
}
